// extracted by mini-css-extract-plugin
module.exports = {"root":"soundRankingSubmit_root__1fMEX","voteFor":"soundRankingSubmit_voteFor__3I8T4","communicate":"soundRankingSubmit_communicate__1Net1"};